<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import { setUrls } from './helpers/baseURLhelper'
import AccessTokenHelper from 'helpers/AccessTokenHelper'
import LangService from 'services/lang'

export default {
  name: 'App',
  computed: {
    ...mapState({
      tvChannels: state => state.guide.tvChannels,
      tvCategories: state => state.guide.tvCategories,
      radioCategories: state => state.guide.radioCategories
    })
  },
  methods: {
    ...mapMutations([
      'UPDATE_COMMUNITY_ID',
      'UPDATE_LANGUAGE_ID',
      'UPDATE_SELECTED_TV_CATEGORY',
      'UPDATE_SELECTED_RADIO_CATEGORY'
    ]),
    ...mapActions([
      'getTvCategories',
      'getRadioCategories',
      'getTvChannels',
      'getRadioChannels',
      'getEpg',
      // 'getEvents'
      'getEvent'
    ]),
    setCommunityAndLangIds () {
      switch (window.location.hostname) {
        case 'epg.sbb.rs':
          LangService.setLanguage('srb')
          this.UPDATE_COMMUNITY_ID(1)
          this.UPDATE_LANGUAGE_ID(404)
          break
        case 'beogrid.net':
          LangService.setLanguage('srb')
          this.UPDATE_COMMUNITY_ID(2)
          this.UPDATE_LANGUAGE_ID(404)
          break
        case 'epg.telemach.si':
          LangService.setLanguage('sl')
          this.UPDATE_COMMUNITY_ID(8)
          this.UPDATE_LANGUAGE_ID(386)
          break
        case 'epg.telemach.ba':
          LangService.setLanguage('bih')
          this.UPDATE_COMMUNITY_ID(12)
          this.UPDATE_LANGUAGE_ID(59)
          break
        case 'epg.telemach.me':
          LangService.setLanguage('cg')
          this.UPDATE_COMMUNITY_ID(5)
          this.UPDATE_LANGUAGE_ID(10001)
          break
        case 'epg.nova.gr':
          LangService.setLanguage('el')
          this.UPDATE_COMMUNITY_ID(35)
          this.UPDATE_LANGUAGE_ID(164)
          break
        default:
          LangService.setLanguage('srb')
          this.UPDATE_COMMUNITY_ID(1)
          this.UPDATE_LANGUAGE_ID(404)
      }
    }
  },
  async created () {
    setUrls(window.location.hostname)
    await AccessTokenHelper.initialLogin()

    this.setCommunityAndLangIds()
    await this.getTvCategories()
    await Promise.all([
      this.getRadioCategories(),
      this.getTvChannels({
        imageSize: 'L'
      }),
      this.getRadioChannels({
        imageSize: 'L'
      })
    ])

    this.UPDATE_SELECTED_TV_CATEGORY(this.tvCategories.find(item => item.id === process.env.DEFAULT_TV_CAT_ID))
    this.UPDATE_SELECTED_RADIO_CATEGORY(this.radioCategories.find(item => item.id === process.env.DEFAULT_RADIO_CAT_ID))
  }
}
</script>

<style lang="scss" src="./scss/style.scss"></style>



// WEBPACK FOOTER //
// src/App.vue